import { getClientLabel } from 'src/utils/clientLabels'
import { Button, Checkbox, Col, Image, Modal, Row, Table, Typography, Tabs } from 'antd'
import moment from 'moment'
import Head from 'next/head'
import Link from 'next/link'
import React from 'react'
import { useRouter } from 'next/router'
import { handleURI } from 'src/utils/common'
import * as api from 'src/configs/API'

import { useEffect, useState } from 'react'
import {
	BoxIcon,
	BuildingIcon,
	CODIcon,
	DeliveryCarIcon,
	EmptyBoxIcon,
	LocationLightIcon,
	PhoneOutlineIcon,
} from 'src/components/CustomIcon'
import CustomTag from 'src/components/CustomTag'
import BASE_CONFIG from 'src/configs/base'
import MENU_CONFIGS from 'src/configs/menu'
import { formatWeight, formatMoney } from 'src/utils/common'
import dashboardService from 'src/services/dashboard.service'
import request from 'src/utils/request'
import APIConstants, { PMS_APIs, TRACKING_API } from 'src/configs/API'
import RecaptchaModal from './recaptcha'

const ENUM_STATUS = {
	new: [20, 21],
	processing: [27, 25, 24, 23, 16],
	success: [30, 28],
	fail: [18, 19, 32, 20],
}

const HeaderTitle = ({ title, desc, isExport, onExport }) => (
	<div className="header-title">
		<Typography.Title level={4} className="text title">
			{title}
		</Typography.Title>
		<Typography.Text
			className={`text ${isExport ? 'export' : 'label'}`}
			onClick={() => isExport && onExport()}
		>
			{desc}
		</Typography.Text>
	</div>
)

const ContentItem = ({ label, value }) => (
	<div className="content-item">
		<Typography.Text className="text label">{label}:</Typography.Text>
		<Typography.Text className="text value">{value}</Typography.Text>
	</div>
)

const LoginRequire = ({ }) => (
	<div className="login-require">
		<Typography.Text className="text info">
			Vui lòng{' '}
			<Link href={MENU_CONFIGS.SIGN_IN_REDIRECT}>
				<Typography.Text className="text login">Đăng nhập</Typography.Text>
			</Link>{' '}
			hoặc{' '}
			<Link href={MENU_CONFIGS.SIGN_UP_REDIRECT}>
				<Typography.Text className="text login">Tư vấn báo giá</Typography.Text>
			</Link>{' '}
			thành khách hàng chính thức của
			<Typography.Text className="text warn"> 247Express</Typography.Text>
		</Typography.Text>
		<Typography.Text className="text info">để xem đầy đủ thông tin đơn hàng</Typography.Text>
	</div>
)
const InfoItem = ({ color, title, desc, phone, address, name }) => (
	<div className="info-item">
		<div className="tag" style={{ backgroundColor: color }} />
		<div className="info-content">
			<Typography.Title level={4} className="text title">
				{title}
			</Typography.Title>
			<Typography.Text className="text label">{desc}</Typography.Text>
			<div className="content no-border">
				<div className="detail-content">
					<BuildingIcon />
					<Typography.Text className="text info">{name}</Typography.Text>
				</div>
				<div className="detail-content">
					<LocationLightIcon />
					<Typography.Text className="text info">{address}</Typography.Text>
				</div>
				<div className="detail-content">
					<PhoneOutlineIcon />
					<Typography.Text className="text info">{phone}</Typography.Text>
				</div>
			</div>
		</div>
	</div>
)

const TrackingOrder = ({
	orderDetail,
	orderPackage,
	user,
	isUserOwner,
	orderHistory,
	setIsDetail,
	setIsSplitOrder,
}) => {
	const [listImages, setListImages] = useState([])
	const [captchaToken, setCaptchaToken] = useState(null)
	const [openCaptcha, setOpenCaptcha] = useState(false)

	const [content, setContent] = useState(null)
	const [showCollapse, setShowCollapse] = useState(false)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isModalVisibleHistory, setIsModalVisibleHistory] = useState(false)

	const isUserLogin = user?.clientID
	const router = useRouter()

	const showModalHistory = () => {
		setIsModalVisibleHistory(true)
	}

	const closeModalHistory = () => {
		setIsModalVisibleHistory(false)
	}

	const showModal = () => {
		setIsModalVisible(true)
	}

	const handleOk = () => {
		setIsModalVisible(false)
	}

	const handleCancel = () => {
		setIsModalVisible(false)
	}

	const [isModalPaymentVisible, setIsModalPaymentVisible] = useState(false)

	const showModalPayment = () => {
		setIsModalPaymentVisible(true)
	}

	const handleOkPayment = () => {
		setIsModalPaymentVisible(false)
	}

	const handleCancelPayment = () => {
		setIsModalPaymentVisible(false)
	}

	const [isModalExtraServiceVisible, setIsModalExtraServiceVisible] = useState(false)

	const showModalExtraService = () => {
		setIsModalExtraServiceVisible(true)
	}

	const handleOkExtraService = () => {
		setIsModalExtraServiceVisible(false)
	}

	const handleCancelExtraService = () => {
		setIsModalExtraServiceVisible(false)
	}

	useEffect(() => {
		if (orderDetail?.commonInfo) {
			setContent(orderDetail?.commonInfo)
		}

	}, [orderDetail])
	useEffect(() => {
		if (captchaToken) {
			getImages();
		}
	}, [captchaToken])
	const handleCaptchaSuccess = () => {
		setCaptchaToken("...")
		setOpenCaptcha(false)
	}
	const getImages = () => {
		let req = {
			OrderCode: orderDetail?.order?.orderCode,
			ClientID: user?.clientID,
			Token: user?.token
		};
		let url = `${TRACKING_API}${api.PMS_APIs.API_TRACKING_ORDER_IMAGE_VIEW}`;
		request.pmsApi.post(
			url,
			req
		)
			.then((res) => {
				if (!res.isError)
					setListImages(res?.imageURLs)
			})
			.catch((err) => {
				console.log(err)
			})
	}

	const columns = [
		{
			title: 'Ngày giờ',
			dataIndex: 'dateChange',
			key: 'dateChange',
			render: (text, record, index) => (
				<span>{text && moment(text).format('DD-MM-YYYY HH:mm')}</span>
			),
			width: 200,
		},
		{
			title: 'Địa điểm',
			dataIndex: 'location',
			key: 'location',
		},
		{
			title: 'Tình trạng',
			dataIndex: 'statusName',
			key: 'statusName',
		},
		{ title: 'Ghi chú', dataIndex: 'notes', key: 'notes' },
	]

	const columnsHistory = [
		{
			title: 'Mã vận đơn',
			dataIndex: 'orderCode',
			key: 'orderCode',
		},
		{
			title: 'Ngày sửa',
			dataIndex: 'dateChange',
			key: 'dateChange',
			render: (text, record, index) => (
				<span>{text && moment(text).format('DD-MM-YYYY HH:mm')}</span>
			),
			width: 200,
		},
		{
			title: 'Người sửa',
			dataIndex: 'customerID',
			key: 'customerID',
			width: 150,
		},

		{
			title: 'Nội dung sửa',
			dataIndex: 'changeInfo',
			key: 'changeInfo',
			render: (text) =>
				text.split('<br>').map((e) => (
					<>
						<Typography.Text>{e}</Typography.Text>
						<br />
					</>
				)),
		},
	]

	const columnsModal = [
		{
			title: 'STT',
			dataIndex: 'id',
			key: 'id',
			render: (text, record, index) => <span>{index + 1}</span>,
		},
		{
			title: 'Mã kiện',
			dataIndex: 'id',
			key: 'id',
		},
		{
			title: 'TL thực (kg)',
			dataIndex: 'realWeight',
			key: 'realWeight',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều dài (cm)',
			dataIndex: 'length',
			key: 'length',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều rộng (cm)',
			dataIndex: 'width',
			key: 'width',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều cao (cm)',
			dataIndex: 'height',
			key: 'height',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'TL quy đổi (kg)',
			dataIndex: 'calWeight',
			key: 'calWeight',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Tl tính giá (kg)',
			dataIndex: 'weight',
			key: 'weight',
			render: (text) => <span>{formatWeight(text)}</span>,
			// hidden: ['IM', 'IE'].includes(orderPackage?.serviceTypeID),
			className: ['IM', 'IE'].includes(orderPackage?.serviceTypeID) ? '' : 'hidden-column',
		},
		{
			title: 'Nội dung',
			dataIndex: 'description',
			key: 'description',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
	]

	const columnExtraService = [
		{
			title: 'STT',
			dataIndex: 'id',
			key: 'id',
			render: (text, record, index) => <span>{index + 1}</span>,
		},
		{
			title: 'Tên dịch vụ gia tăng',
			dataIndex: 'serviceName',
			key: 'serviceName',
		},
	]

	const columnOrderDetailInfo = [
		{
			title: 'STT',
			dataIndex: 'id',
			key: 'id',
			render: (text, record, index) => <span>{index + 1}</span>,
		},
		{
			title: 'Mã vận đơn',
			dataIndex: 'orderCode',
			key: 'orderCode',
			render: (text, record) => (
				<a
					aria-label={'247Express-Nhanh hơn bạn nghĩ'}
					onClick={() => {
						router.push('/tra-cuu-van-don/' + handleURI(record?.orderCode))
						setIsSplitOrder(true)
					}}
				>
					{text}
				</a>
			),
		},
		{
			title: 'SL kiện',
			dataIndex: 'quantity',
			key: 'quantity',
		},
		{
			title: 'Bưu cục',
			dataIndex: 'postOfficeID',
			key: 'postOfficeID',
		},
		{
			title: 'Trạng thái',
			dataIndex: 'statusName',
			key: 'statusName',
			render: (text) => text && <CustomTag text={text} />,
		},
		{
			title: 'TL thực (kg)',
			dataIndex: 'realWeight',
			key: 'realWeight',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều dài (cm)',
			dataIndex: 'length',
			key: 'length',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều rộng (cm)',
			dataIndex: 'width',
			key: 'width',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Chiều cao (cm)',
			dataIndex: 'height',
			key: 'height',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'TL quy đổi (kg)',
			dataIndex: 'calWeight',
			key: 'calWeight',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
		{
			title: 'Tl tính giá (kg)',
			dataIndex: 'weight',
			key: 'weight',
			render: (text) => <span>{formatWeight(text)}</span>,
			// hidden: ['IM', 'IE'].includes(orderPackage?.serviceTypeID),
			className: ['IM', 'IE'].includes(orderPackage?.serviceTypeID) ? '' : 'hidden-column',
		},
		{
			title: 'Ghi chú',
			dataIndex: 'notes',
			key: 'notes',
			render: (text) => <span>{formatWeight(text)}</span>,
		},
	]

	const OrderInfoComponent = (
		<>
			<div className="header">
				<Row gutter={[4, 4]}>
					<Col xl={4} lg={4} md={24} sm={24} xs={24}>
						<HeaderTitle title={orderDetail?.order?.orderCode} desc={'Mã vận đơn'} />
					</Col>
					<Col xl={4} lg={4} md={24} sm={24} xs={24}>
						{orderDetail?.order?.originalOrder && (
							<HeaderTitle title={orderDetail?.order?.originalOrder} desc={'Mã vận đơn gốc'} />
						)}
					</Col>
					<Col xl={14} lg={14} md={24} sm={24} xs={24}>
						{orderDetail?.order?.externalCode && (
							<HeaderTitle
								title={orderDetail?.order?.externalCode}
								desc={'Mã đơn hàng khách hàng'}
							/>
						)}
					</Col>
					<Col xl={2} lg={2} md={24} sm={24} xs={24} className="status">
						<CustomTag text={orderDetail?.order?.statusName} />
					</Col>
				</Row>
			</div>
			<div className="content">
				<Row gutter={[{ xs: 8, sm: 12, md: 32, lg: 64 }, 12]}>
					<Col xl={6} lg={6} md={24} sm={24} xs={24}>
						<Row gutter={[8, 8]}>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Ngày gửi'}
									value={
										orderDetail?.order?.acceptedTime &&
										moment(orderDetail?.order?.acceptedTime).format('DD/MM/YYYY')
									}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Ngày nhận dự kiến'}
									value={
										orderDetail?.order?.estimateDeliveryTimeStr
									}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Loại hình'}
									value={orderDetail?.order?.mailerType === 'TL' ? 'Tài liệu' : 'Hàng hoá'}
								/>
							</Col>
							{isUserLogin &&
								<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									<ContentItem label={'Nội dung'} value={orderDetail?.order?.note} />
								</Col>
							}
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Lô chương trình'}
									value={<Checkbox checked={orderDetail?.order?.isPackagePrice} />}
								/>
							</Col>
						</Row>
					</Col>
					<Col xl={6} lg={6} md={24} sm={24} xs={24}>
						<Row gutter={[8, 8]}>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem label={'Số kiện hàng'} value={orderDetail?.order?.quantity} />
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem label={'Dài (Cm)'} value={orderDetail?.order?.length} />
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem label={'Rộng (Cm)'} value={orderDetail?.order?.width} />
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem label={'Cao (Cm)'} value={orderDetail?.order?.height} />
							</Col>
						</Row>
					</Col>
					<Col xl={6} lg={6} md={24} sm={24} xs={24}>
						<Row gutter={[8, 8]}>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Trọng lượng thực (Kg)'}
									value={formatWeight(orderDetail?.order?.realWeight)}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Trọng lượng quy đổi (Kg)'}
									value={formatWeight(orderDetail?.order?.calWeight)}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Trọng lượng tính giá (Kg)'}
									value={formatWeight(orderDetail?.order?.weight)}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								{isUserLogin && isUserOwner && (
									<ContentItem
										label={'Giá trị hàng hoá'}
										value={`${formatMoney(orderDetail?.order?.goodsValue)} `}
									/>
								)}
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								{/* <Typography.Text className="text label">Lịch sử sửa đơn</Typography.Text>
											<Button danger onClick={showModal}>
												Xem chi tiết
											</Button> */}
								{isUserLogin && isUserOwner && (
									<ContentItem
										label={'Lịch sử sửa đơn'}
										value={
											<Button danger onClick={showModalHistory}>
												Xem chi tiết
											</Button>
										}
									/>
								)}
							</Col>
							
						</Row>
					</Col>
					<Col xl={6} lg={6} md={24} sm={24} xs={24}>
						<Row gutter={[8, 8]}>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Tiền thu hộ'}
									value={`${formatMoney(orderDetail?.order?.codAmount || 0)} `}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={getClientLabel(user?.clientID, 'Ghi chú đặc biệt')}
									value={orderDetail?.order?.specialInstruction}
								/>
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem label={'Dịch vụ'} value={orderDetail?.order?.serviceTypeName} />
							</Col>
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
								<ContentItem
									label={'Dịch vụ gia tăng'}
									value={
										orderDetail?.order?.extraServices?.filter((item) => item.type === 2).length <=
											1 ? (
											orderDetail?.order?.extraServices?.filter((item) => item.type === 2)[0]
												?.serviceName
										) : (
											<a
												aria-label={'247Express-Nhanh hơn bạn nghĩ'}
												onClick={showModalExtraService}
											>
												Xem chi tiết
											</a>
										)
									}
								/>
							</Col>
							{isUserLogin && isUserOwner && orderPackage && orderPackage?.packages?.length > 1 && (
								<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									{/* <Typography.Text className="text label">Chi tiết kiện</Typography.Text>
												<Button danger onClick={showModal}>
													Xem chi tiết
												</Button> */}
									<ContentItem
										label={'Chi tiết kiện'}
										value={
											<Button danger onClick={showModal}>
												Xem chi tiết
											</Button>
										}
									/>
								</Col>
							)}
							{isUserLogin && isUserOwner && (
							<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									<ContentItem
										label={'Giá trị thu khác'}
										value={`${formatMoney(orderDetail?.order?.priceOther || 0)} `}
											
									/>
							</Col>
							)}
							{isUserLogin && isUserOwner && (
								<Col xl={24} lg={24} md={24} sm={24} xs={24}>
									<ContentItem label={'Ghi chú thu khác'} value={orderDetail?.order?.notePriceOther} />
								</Col>
							)}
							
						</Row>
					</Col>
				</Row>
			</div>
		</>
	)

	const OrderDetailInfoComponent = (data) => (
		<>
			<div className="header">
				<Row gutter={[4, 4]}>
					<Col xl={4} lg={4} md={24} sm={24} xs={24}>
						<HeaderTitle title={orderDetail?.order?.orderCode} desc={'Mã vận đơn'} />
					</Col>
					<Col xl={4} lg={4} md={24} sm={24} xs={24}>
						{orderDetail?.order?.originalOrder && (
							<HeaderTitle title={orderDetail?.order?.originalOrder} desc={'Mã vận đơn gốc'} />
						)}
					</Col>
					<Col xl={14} lg={14} md={24} sm={24} xs={24}>
						{orderDetail?.order?.externalCode && (
							<HeaderTitle
								title={orderDetail?.order?.externalCode}
								desc={'Mã đơn hàng khách hàng'}
							/>
						)}
					</Col>
					<Col xl={2} lg={2} md={24} sm={24} xs={24} className="status">
						<CustomTag text={orderDetail?.order?.statusName} />
					</Col>
				</Row>
			</div>
			<div className="content">
				<div className="info-table">
					<Table
						dataSource={data || []}
						columns={columnOrderDetailInfo}
						pagination={false}
						rowKey={'orderCode'}
						locale={{ emptyText: 'Không có dữ liệu' }}
						scroll={{ x: 600 }}
					/>
				</div>
			</div>
		</>
	)

	return orderDetail && !orderDetail?.isError ? (
		<div className="tracking-order-wrapper">
			<Head>
				<title>Theo dõi đơn hàng | {BASE_CONFIG.SLOGAN}</title>
			</Head>
			<Row gutter={[12, 32]}>
				{/* Thông tin chi tiết */}
				<Col xl={24} lg={24} md={24} sm={24} xs={24}>
					<div className="tracking-order info">
						<Tabs
							defaultActiveKey="1"
							onChange={() => { }}
							items={[
								{
									label: `Thông tin vận đơn`,
									key: '1',
									children: OrderInfoComponent,
								},
								orderDetail?.isSplitOrder && {
									label: `Thông tin vận đơn liên quan`,
									key: '2',
									children: OrderDetailInfoComponent(orderDetail?.refOrderInfos),
								},
							]}
						/>
					</div>
				</Col>

				{/* Thông tin ảnh, tiến trình */}

				<Col xl={24} lg={24} md={24} sm={24} xs={24}>
					<div className={`tracking-order status`}>
						{/* <div className={`tracking-order status ${!showCollapse && 'hide'}`}> */}
						{/* <div className="button-collapse" onClick={() => setShowCollapse(!showCollapse)}>
							<div className="label" style={{ fontSize: 16 }}>
								{showCollapse ? 'Thu gọn' : 'Chi tiết tiến trình'}
							</div>
						</div> */}
						{ENUM_STATUS.fail.includes(Number(orderDetail?.order?.status)) ? (
							<div className="wrapper-status-fail">
								{(orderDetail?.order?.delayDeliveryName || '') +
									(orderDetail?.order?.deliveryNotes || '')}
							</div>
						) : (
							<div className={`wrapper-status`}>
								<div
									className={`status-box ${ENUM_STATUS.new.includes(Number(orderDetail?.order?.status)) && 'done'
										}`}
								>
									<BoxIcon style={{ color: '#5E6278' }} className="icon" />
									<div className="title">Đơn mới</div>
								</div>
								<div className="dash"></div>

								<div
									className={`status-box ${ENUM_STATUS.processing.includes(Number(orderDetail?.order?.status)) && 'done'
										}`}
								>
									<DeliveryCarIcon style={{ color: '#5E6278' }} className="icon" />
									<div className="title">Đang xử lý</div>
								</div>
								<div className="dash"></div>

								<div
									className={`status-box ${ENUM_STATUS.success.includes(Number(orderDetail?.order?.status)) && 'done'
										}`}
								>
									<CODIcon style={{ color: '#5E6278' }} className="icon" />
									<div className="title">Hoàn thành</div>
								</div>
							</div>
						)}
						<div className={`wrapper-image-list`}>
							<div className="header">
								<HeaderTitle
									title={`Thông tin xác nhận ${orderDetail?.order?.deliveryTo
										? '- Người ký nhận: ' + orderDetail?.order?.deliveryTo
										: ''
										}`}
									desc={isUserLogin ? 'Hình ảnh xác nhận đã giao hàng thành công từ hệ thống 247Express' : ''}
								/>
							</div>
							<div className="image-list">
								{(listImages?.length <= 0 && orderDetail?.order?.isShowImage) &&
									<div onClick={() => {
										if (isUserLogin === false) {
											setOpenCaptcha(true);
										} else {
											getImages();
										}
									}} style={{ width: 64, height: 64, border: "1px dashed #ff0000", fontSize: 12, cursor: 'pointer' }}>
										<span style={{ marginTop: 24, marginLeft: 8, display: "block" }}>Xem ảnh</span>
									</div>
								}
								{listImages?.length
									? listImages?.map((item) => (
										<Image
											key={item}
											className="image-item"
											//src={item.replace('247tech.xyz:30110', 'img-kh.247post.vn')}
											src={item}
										/>
									))
									: null}
							</div>
						</div>
						<div className={`wrapper-timeline`}>
							<div className="header">
								<HeaderTitle
									title={'Chi tiết tiến trình'}
									desc={'Tiến trình giao hàng được cập nhật liên tục từ hệ thống 247Express'}
								/>
							</div>
							<div className="timeline">
								<Table
									dataSource={orderDetail?.trackingData}
									columns={columns}
									pagination={false}
									locale={{ emptyText: 'Không có dữ liệu' }}
									scroll={{ x: 600 }}
								/>
							</div>
						</div>
					</div>
				</Col>

				{isUserLogin && (
					<React.Fragment>
						<Col xl={12} lg={12} md={12} sm={24} xs={24}>
							<div className="tracking-order sender">
								<InfoItem
									color={'#FF9E15'}
									title={'Thông tin người gửi'}
									desc={'Các thông tin cơ bản của người gửi'}
									name={orderDetail?.order?.senderName}
									address={orderDetail?.order?.senderAddress}
									phone={orderDetail?.order?.senderPhone}
								/>
							</div>
						</Col>
						<Col xl={12} lg={12} md={12} sm={24} xs={24}>
							<div className="tracking-order receiver">
								<InfoItem
									color={'#9F3123'}
									title={'Thông tin người nhận'}
									desc={'Các thông tin cơ bản của người nhận'}
									name={orderDetail?.order?.receiverName}
									address={orderDetail?.order?.receiverAddress}
									phone={orderDetail?.order?.receiverPhone}
								/>
							</div>
						</Col>
					</React.Fragment>
				)}
				{isUserLogin && orderDetail?.order?.ttdnInfo && (
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						<div className="tracking-order fee">
							<div className="header">
								<Row justify="space-between" align="middle">
									<Col xl={8} lg={8} md={24} sm={24} xs={24}>
										<HeaderTitle
											title={'Thông tin thanh toán đầu nhận'}
											desc={
												orderDetail?.order?.ttdnInfo?.isExportInvoice
													? 'Xuất hoá đơn'
													: 'Không xuất hoá đơn'
											}
											isExport={orderDetail?.order?.ttdnInfo?.isExportInvoice}
											onExport={() => {
												dashboardService.downloadInvoice(orderDetail?.order?.orderCode)
											}}
										/>
									</Col>
									<Col xl={6} lg={6} md={24} sm={24} xs={24} className="detail-button">
										<Typography.Text className="text label">
											<span style={{ color: '#181c32' }}>Thông tin xuất hóa đơn tiền mặt</span>
										</Typography.Text>
										<Button danger onClick={showModalPayment}>
											Xem chi tiết
										</Button>
									</Col>
								</Row>
							</div>
							<div className="content">
								<Row gutter={[{ xs: 8, sm: 30, md: 80, lg: 100 }, 8]}>
									<Col xl={8} lg={8} md={24} sm={24} xs={24}>
										<ContentItem label={'Phương thức thanh toán'} value={'Tiền mặt'} />
									</Col>
									<Col xl={8} lg={8} md={24} sm={24} xs={24}>
										<ContentItem
											label={'Người thanh toán'}
											value={orderDetail?.order?.ttdnInfo?.payerName}
										/>
									</Col>
									<Col xl={8} lg={8} md={24} sm={24} xs={24}>
										<ContentItem
											label={'Số điện thoại thanh toán'}
											value={orderDetail?.order?.ttdnInfo?.payerPhone}
										/>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
				)}
				{isUserLogin ? (
					orderDetail?.order?.fees ? (
						<Col xl={24} lg={24} md={24} sm={24} xs={24}>
							<div className="tracking-order fee">
								<div className="header">
									<Row justify="space-between" align="middle" gutter={[0, 10]}>
										<Col xl={8} lg={8} md={24} sm={24} xs={24}>
											<HeaderTitle title={'Cước phí dịch vụ'} desc={'Các khoản phí cho đơn hàng'} />
										</Col>
										<Col xl={6} lg={6} md={24} sm={24} xs={24}>
											<div className="text currency">
												{formatMoney(
													//orderDetail?.order?.fees?.reduce((pre, curr) => pre + curr?.cost, 0)
													orderDetail?.order?.totalServiceCost
												)}{' '}
											</div>
										</Col>
									</Row>
								</div>
								<div className="content">
									<Row gutter={[{ xs: 8, sm: 30, md: 80, lg: 100 }, 8]}>
										{orderDetail?.order?.fees?.map((item) => (
											<Col xl={8} lg={8} md={24} sm={24} xs={24} key={item?.no}>
												<ContentItem label={item?.name} value={`${formatMoney(item?.cost)} `} />
											</Col>
										))}
									</Row>
								</div>
							</div>
						</Col>
					) : null
				) : (
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						<div className="tracking-order fee">
							<div className="header">
								<Row justify="space-between" align="middle">
									<Col xl={8} lg={8} md={24} sm={24} xs={24}>
										<HeaderTitle title={'Cước phí dịch vụ'} desc={'Các khoản phí cho đơn hàng'} />
									</Col>
									{isUserLogin && (
										<Col xl={6} lg={6} md={24} sm={24} xs={24}>
											<div className="text currency">
												{formatMoney(
													//orderDetail?.order?.fees?.reduce((pre, curr) => pre + curr?.cost, 0)
													orderDetail?.order?.totalServiceCost
												)}{' '}
											</div>
										</Col>
									)}
								</Row>
							</div>
							<div className="content">
								{isUserLogin ? (
									<Row gutter={[{ xs: 8, sm: 30, md: 80, lg: 100 }, 8]}>
										{orderDetail?.order?.fees?.map((item) => (
											<Col xl={8} lg={8} md={24} sm={24} xs={24} key={item?.no}>
												<ContentItem label={item?.name} value={`${formatMoney(item?.cost)} `} />
											</Col>
										))}
									</Row>
								) : (
									<LoginRequire />
								)}
							</div>
						</div>
					</Col>
				)}
			</Row>
			<RecaptchaModal
				open={openCaptcha}
				onSuccess={handleCaptchaSuccess}
				onCancel={() => setOpenCaptcha(false)}
			/>
			<Modal
				title={
					<div className="modal-header-info">
						<BoxIcon style={{ fontSize: 20, color: '#CC0000', marginRight: 12 }} />
						<div className="text modal">Thông tin kiện hàng</div>
					</div>
				}
				open={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={false}
				wrapClassName={'tracking-order-wrapper'}
				width={800}
			>
				<div className="info-table">
					<Table
						dataSource={orderPackage?.packages || []}
						columns={columnsModal}
						pagination={false}
						rowKey={'id'}
						locale={{ emptyText: 'Không có dữ liệu' }}
						scroll={{ x: 600 }}
					/>
				</div>
				<div className="info-row">
					<div className="item">
						<div className="title">Số kiện hàng:</div>
						<div className="content">{orderPackage?.quantity}</div>
					</div>
					<div className="item">
						<div className="title">Tổng TL quy đổi:</div>
						<div className="content">{formatWeight(orderPackage?.orderCalWeight)} Kg</div>
					</div>
					<div className="item">
						<div className="title">Tổng TL thực:</div>
						<div className="content">{formatWeight(orderPackage?.orderRealWeight)} Kg</div>
					</div>
					<div className="item">
						<div className="title">Tổng TL tính giá:</div>
						<div className="content">{formatWeight(orderPackage?.orderWeight)} Kg</div>
					</div>
				</div>
			</Modal>
			<Modal
				title={
					<div className="modal-header-info">
						<BoxIcon style={{ fontSize: 20, color: '#CC0000', marginRight: 12 }} />
						<div className="text modal">Lịch sử sửa thông tin đơn hàng</div>
					</div>
				}
				open={isModalVisibleHistory}
				onOk={closeModalHistory}
				onCancel={closeModalHistory}
				footer={false}
				wrapClassName={'tracking-order-wrapper'}
				width={800}
			>
				<div className="info-table">
					<Table
						dataSource={orderHistory}
						columns={columnsHistory}
						pagination={true}
						rowKey={(item) => item}
						locale={{ emptyText: 'Không có dữ liệu' }}
						scroll={{ x: 600 }}
					/>
				</div>
			</Modal>
			<Modal
				title={
					<div className="modal-header-info">
						<BoxIcon style={{ fontSize: 20, color: '#CC0000', marginRight: 12 }} />
						<div className="text modal">Thông tin xuất hóa đơn tiền mặt</div>
					</div>
				}
				open={isModalPaymentVisible}
				onOk={handleOkPayment}
				onCancel={handleCancelPayment}
				footer={false}
				wrapClassName={'tracking-order-wrapper'}
			>
				<div
					className="info-row"
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						rowGap: '12px',
					}}
				>
					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Tên người mua:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.invoiceBuyerName}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Mã số thuế:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.taxCode}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Tên khách hàng (XHĐ):</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.invoiceName}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Email nhận hóa đơn:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.emailInvoice}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>CCCD:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.identityNumber}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Hộ chiếu:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.passportNumber}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>QH ngân sách:</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.budgetRelationshipCode}</div>
					</div>

					<div className="item" style={{ width: '48%', display: 'flex' }}>
						<div className="title" style={{ minWidth: 140 }}>Địa chỉ (XHĐ):</div>
						<div className="content">{orderDetail?.order?.ttdnInfo?.addressInvoice}</div>
					</div>
				</div>
			</Modal>
			<Modal
				title={
					<div className="modal-header-info">
						<BoxIcon style={{ fontSize: 20, color: '#CC0000', marginRight: 12 }} />
						<div className="text modal">Thông tin dịch vụ gia tăng</div>
					</div>
				}
				open={isModalExtraServiceVisible}
				onOk={handleCancelExtraService}
				onCancel={handleCancelExtraService}
				footer={false}
				wrapClassName={'tracking-order-wrapper'}
			>
				<div className="info-table">
					<Table
						dataSource={orderDetail?.order?.extraServices?.filter((item) => item.type === 2)}
						columns={columnExtraService}
						pagination={false}
						rowKey={'extraServiceID'}
						locale={{ emptyText: 'Không có dữ liệu' }}
					/>
				</div>
			</Modal>
		</div>
	) : (
		<div className="tracking-empty">
			<EmptyBoxIcon />
			<Typography.Text className="text">Không có dữ liệu</Typography.Text>
		</div>
	)
}

export default TrackingOrder
